// extracted by mini-css-extract-plugin
export default {"linkPreviewContainer":"on3BLudygPdrSft1BRac","providerIcon":"QBbEUpR8_UoKdtc9gZN4","titleText":"v1rxmclkmycO6O8B2oWM"};